import clsx from "clsx"
import {NumericFormat, NumericFormatProps} from "react-number-format"

interface BlockNumberProps extends NumericFormatProps {
  extraClassName?: string;
  useMonospace?: boolean;
  align?: 'left' | 'right' | 'center';
}

function BlockNumber({
  extraClassName, 
  useMonospace = false, 
  align = 'left', 
  ...rest
}: BlockNumberProps) {
  const className = clsx(
    "c-block-number", 
    extraClassName,
    {
      'c-block-number-monospace': useMonospace,
      'c-block-number-align-right': align === 'right',
      'c-block-number-align-center': align === 'center'
    }
  );

  const style = {
    ...rest.style,
    ...(useMonospace && {
      fontFamily: 'SF Mono, Monaco, Consolas, Liberation Mono, Courier New, monospace',
      fontVariantNumeric: 'tabular-nums'
    }),
    ...(align === 'right' && { textAlign: 'right' as const }),
    ...(align === 'center' && { textAlign: 'center' as const })
  };

  return (
    <NumericFormat
      className={className}
      displayType="text"
      thousandSeparator=","
      decimalSeparator="."
      style={style}
      {...rest}
    />
  )
}

export default BlockNumber
